<template>
  <div class="share-alert">
    <div
      class="box-bg"
      v-if="isWeChat"
      v-cloak
    >
      <div class="iswechat-inset">
        <img src="./img/wechat-tips.png" />
        <img
          src="./img/arrow.png"
          class="arrow"
        />
        <img
          src="./img/wechat-logo.png"
          class="wechat-logo"
        />
        <p class="wechat-tips-msg">ブラウザで開いてください</p>
      </div>

      <img
        src="./img/iswechat-bottom.png"
        class="iswechat-bottom"
      />

    </div>
    <div
      v-show="isShare"
      class="share-box"
      v-cloak
    >
      <div class="share-inset">
        <div class="share-title">
          <img src="./img/alert-logo.png" /><span>NANACO</span>
        </div>
        <div class="share-msg">
          Nanacoでリンクを開きますか？
        </div>
        <div class="share-bottom">
          <span @click="isShare = false">
            キャンセル
          </span>
          <span>
            <a :href="linkUrl">確認</a>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      linkUrl: '',
      isWeChat: false,
      isShare: false
    }
  },
  methods: {
    IsPC () {
      // alert(1)
      var sUserAgent = navigator.userAgent.toLowerCase();
      var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
      var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
      var bIsMidp = sUserAgent.match(/midp/i) == "midp";
      var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
      var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
      var bIsAndroid = sUserAgent.match(/android/i) == "android";
      var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
      var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
      if (bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM || bIsIpad) {
        return true;
      } else if (bIsIpad) {
        return false;
      } else {
        return false;
      }
    },
    //判断微信
    isWeiXin () {
      // alert(1)
      //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
      var ua = window.navigator.userAgent.toLowerCase();
      //通过正则表达式匹配ua中是否含有MicroMessenger字符串
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        this.isWeChat = true
        return true;
      } else {
        return false;
      }
    },
    //判断安卓
    isAndroid () {
      var u = navigator.userAgent;
      if (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1 || u.indexOf('Adr') > -1) {
        if (window.ShowFitness !== undefined) return true;
      }
      return false;
    },
    //判断IOS
    isIos () {
      var u = navigator.userAgent;
      if (u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1) {
        return true;
      }
      return false;
    },
    init () {
      // alert(4)
      this.isWeiXin()
      let type = this.$route.query.type
      let id = Number(this.$route.query.id)
      let isPe = true
      if (this.IsPC() || isPe) {
        if (type && id) {
          if ((!this.isWeiXin() && isPe === true) || (!this.isWeiXin() && this.isIos())) {
            if (this.isIos()) {
              let linkUrl = 'type=' + type + '&id=' + id
              let wakeUpProtocol = linkUrl
              this.linkUrl = "Nanacocomjlkfzhongying://" + linkUrl
              this.isShare = true
              location.href = "Nanacocomjlkfzhongying://" + wakeUpProtocol

            } else {
              let linkUrl = 'type=' + type + '&id=' + id
              let wakeUpProtocol = linkUrl
              this.linkUrl = "nanaco://nanaco?" + linkUrl
              location.href = "nanaco://nanaco?" + wakeUpProtocol
              this.isShare = true
            }

          }
        } else {
          // localStorage.removeItem('int')
        }
      } else { }
    }
  }
}
</script>
<style scoped>
.share-box {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  font-size: 1rem;
  z-index: 999999;
}

.share-inset {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  text-align: center;
  background: #fff;
  width: 70%;
  height: 6.7rem;
  border-radius: 15px;
  overflow: hidden;
}
.share-inset * {
  box-sizing: border-box;
  padding: 5px;
  text-decoration: none;
  color: #222;
}
.share-title {
  height: 2.5rem;
  background: #e8c921;
  position: relative;
  line-height: 3rem;
  font-size: 1rem;
}
.share-title img {
  height: 2rem;
  padding: 0;
  margin-top: 0.2rem;
  vertical-align: top;
  position: absolute;
  left: 1rem;
}
.share-title span {
  display: inline-block;
  height: 3rem;
  padding: 0;
  line-height: 2.5rem;
  vertical-align: top;
  font-size: 0.9rem;
}
.share-msg {
  height: 2rem;
  line-height: 1.5rem;
  font-size: 0.8rem;
}
.share-bottom {
  height: 30px;
  display: flex;
}
.share-bottom span {
  display: inline-block;
  height: 35px;
  flex: 1;
  line-height: 25px;
  border-top: solid 1px #ddd;
  font-size: 0.8rem;
}
.share-bottom span:nth-child(1) {
  border-right: solid 1px #ddd;
}
.box-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #e8ce5f;
  z-index: 999999;
}
.iswechat-inset {
  width: 100%;
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  /* border:solid 1px red; */
}
.iswechat-bottom {
  width: 100%;
  position: absolute;
  bottom: 0;
  height: auto;
}
.wechat-logo {
  width: 100px !important;
  height: 100px !important;
  top: 140px;
  left: 0;
  right: 0;
  margin: auto;
  position: absolute;
}
.wechat-tips-msg {
  width: 100%;
  position: absolute;
  top: 260px;
  text-align: center;
  font-size: 20px;
  font-family: A-OTF Kaisho MCBK1 Pro;
  font-weight: normal;
  color: rgba(53, 53, 53, 1);
  line-height: 25px;
}
.iswechat-inset img {
  width: 100%;
  height: auto;
}
.arrow {
  width: 100px !important;
  height: auto !important;
  position: absolute;
  top: 25px;
  right: 25px;
  /* border:solid 1px green; */
}
.arrow img {
  width: 100%;
  height: auto;
}
.wechat-logo-set {
  width: 87.5px;
  height: 100px;
  position: absolute;
  bottom: 0;
  left: 0;
  /* border:solid 1px white; */
}
.wechat-logo-set img {
  height: 100%;
  width: auto;
}
.wechat-tips-set {
  width: 87.5px;
  height: 87.5px;
  position: absolute;
  bottom: 0;
  right: 0;
  /* border:solid 1px yellow; */
}
.wechat-tips-set p {
  color: #fff;
  font-size: 1rem;
  text-align: center;
  margin: 0;
}
.wechat-tips-set-image {
  margin: 6.25px 0;
  text-align: center;
}
.wechat-tips-set-image img {
  width: 30px;
  height: auto;
}
[v-cloak] {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/public-modules/share.vue